import { createFileRoute } from '@tanstack/react-router';
import { routeContracts } from '@/app/router/routeContracts';

export const Route = createFileRoute('/products-chains')({
  component: routeContracts.productsChains.component,
});
